// extracted by mini-css-extract-plugin
export default {"bgPicked":"components_bgPicked__ymKZQ","bgSelected":"components_bgSelected__n4hwo"};